export const QUERY_PARAMS = {
  CHAT: 'chat'
}
